import { useState } from 'react';
import { formatWholeUsd } from '../text-utils';

// Backs a whole-dollar currency <input> whose value is reformatted (via formatWholeUsd) when not
// focused. Reformatting on every keystroke while the field is focused makes the caret jump to the
// end and an emptied field snap straight back to "$0" -- this instead shows the raw typed text
// while focused, and only reformats on blur. `value` may be null for a caller with an "unset"
// state of its own (displays as an empty field, same as 0 while focused for easy editing).
export const useCurrencyInputDisplay = (value: number | null) => {
  const [rawInput, setRawInput] = useState<string | null>(null);

  return {
    displayValue: rawInput ?? (value == null ? '' : formatWholeUsd(value)),
    onFocus: () => setRawInput(value == null || value === 0 ? '' : String(value)),
    onChangeText: (text: string) => setRawInput(text),
    onBlur: () => setRawInput(null)
  };
};
